(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("scheduledReportForm", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/reports/scheduledReportFormView.html",
            controller: ["$localStorage", "$state", ScheduledReportFormCtrl],
            controllerAs: "vm"
        };
        function ScheduledReportFormCtrl($localStorage, $state) {
            var vm = this;
            vm.state = $state.current.name === "main.reporting.addScheduledReport" ? "Add" : "Edit";
            vm.storage = $localStorage.scheduledReports;
            vm.cronConfig = {
                options: {
                    allowMinute: false
                }
            };
            if (vm.state === "Add") {
                vm.pageTitle = "Add Scheduled Report Job";
                vm.savedReports = $localStorage.myReports.concat($localStorage.sharedReports);
                vm.report = {
                    type: "pdf",
                    enabled: true
                };
            }
            else {
                vm.pageTitle = "Edit Scheduled Report Job";
                if ($state.params.report) {
                    vm.report = angular.copy($state.params.report);
                    vm.original = $state.params.report;
                }
                else {
                    $state.go("main.reporting.scheduledReports");
                    return;
                }
            }
            vm.save = function () {
                if (vm.saving)
                    return;
                if (vm.form.$valid) {
                    vm.saving = true;
                    var frequency = window.prettyCron.toString(vm.report.cron);
                    if (vm.state === "Add") {
                        var job = {
                            name: vm.report.name,
                            report: vm.report.report,
                            frequency: frequency,
                            cron: vm.report.cron,
                            recipients: vm.report.recipients,
                            type: vm.report.type,
                            enabled: vm.report.enabled
                        };
                        $localStorage.scheduledReports.push(job);
                    }
                    else {
                        vm.report.frequency = frequency;
                        angular.extend(vm.original, vm.report);
                    }
                    vm.saving = false;
                    $state.go("main.reporting.scheduledReports");
                }
                else {
                    vm.showErrors = true;
                }
            };
            vm.cancel = function () {
                $state.go("main.reporting.scheduledReports");
            };
        }
    });
}());
